import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';

interface DataProps {
  className?: string;
  text?: string;
}

export const NoData = (props: DataProps) => {
  const { t } = useTranslation();

  const text = props.text ?? t('noData.default');
  return <div className={cn('my-auto flex items-center justify-center p-6 text-slate dark:text-ice', props.className)}>{text}</div>;
};
